import { render, staticRenderFns } from "./ProfitAndRegistrationContent.vue?vue&type=template&id=05cc1f1e&scoped=true&"
import script from "./ProfitAndRegistrationContent.vue?vue&type=script&lang=js&"
export * from "./ProfitAndRegistrationContent.vue?vue&type=script&lang=js&"
import style0 from "./ProfitAndRegistrationContent.vue?vue&type=style&index=0&id=05cc1f1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cc1f1e",
  null
  
)

export default component.exports